// extracted by mini-css-extract-plugin
export default {"container__removerproduto":"RemoverProduto_container__removerproduto__kixcj","back__btn":"RemoverProduto_back__btn__Dix--"};